module.exports = __webpack_public_path__ + "static/media/3DPPA31.884131eb.jpg";